// extracted by mini-css-extract-plugin
export var select = "styles-module--select--N09vu";
export var placeholder = "styles-module--placeholder--IhGU9";
export var invalid = "styles-module--invalid--gBd54";
export var disabled = "styles-module--disabled--iOM6U";